<template>
  <div class="response_table permission_table">
    <table>
      <thead style="">
        <tr>
          <th scope="col" class="name"> {{translate('user.roles.permission_name')}} </th>
          <th scope="col" class="permissions"> {{translate('user.roles.permission_for_role')}} </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(permission, permission_key) in permission_list" :key="permission_key" class="role">
          <td data-label="Name" class="name">
            <span>{{ permission.name }}</span>
          </td>
          <td data-label="Description" class="permissions">
            <span>{{ permission.description }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

export default {
  name: 'PermissionList',
  props: ['permission_list'],
}

</script>

<style lang="scss" scoped>
.response_table{
  font-size: 14px;

  &.permission_table{
    height: 100%;
    .table_title{
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 0;
      height: 25px;
    }
    table{
      height: calc(100% - 33px);
      .name{
        text-align: left;
        width: 40%;
      }
      .permissions{
        text-align: left;
      }
    }
  }
}

</style>
